document.addEventListener("DOMContentLoaded", function () {

  /* ==== NORMAL COUNT ANIMATION ==== */
  const counters = document.querySelectorAll('.va-count');

  counters.forEach(counter => {
    const target = Number(counter.dataset.target || 0);
    let current = 0;
    const duration = 5000;
    const start = performance.now();

    function animateCount(ts) {
      const progress = Math.min((ts - start) / duration, 1);
      const value = Math.floor(progress * target);
      counter.textContent = value;
      if (progress < 1) requestAnimationFrame(animateCount);
      else counter.textContent = target;
    }

    requestAnimationFrame(animateCount);
  });

  /* ==== LIVE MONEY COUNTER ==== */
  let moneyEl = document.getElementById("liveMoney");
  if (moneyEl) {
    let value = Number(moneyEl.textContent);
    setInterval(() => {
      value += 15;
      moneyEl.textContent = value.toLocaleString("pl-PL");
    }, 200);
  }

  /* ==== LIVE MINUTES COUNTER ==== */
  let minutesEl = document.getElementById("liveMinutes");
  if (minutesEl) {
    let value = Number(minutesEl.textContent);
    setInterval(() => {
      value += 3;
      minutesEl.textContent = value.toLocaleString("pl-PL");
    }, 300);
  }

});
